/**
 * Scoped cell state styles for inline date editing (dl-59431).
 * Per Figma "Table Cells — Type: Date" specs:
 *
 * Cell:      120px min / 160px max width, 32px height
 * Padding:   spacing/sm = 12px L+R (read-only), spacing/xs = 8px L+R (editing)
 * Gap:       spacing/xs = 8px
 * Typography: Body xs/Regular, text-primary
 * Border:    Bottom 0.5px, Alignment: Inside (edit/error states)
 * Hover:     outline all sides (0.5px grey[200])
 * Icon:      CalendarDots 20x20, outline/light, fg-primary (hover/focus only)
 */

import { colors } from 'styles/theme/colors';
import type { CSSProperties } from 'react';

const cellBorderSubtle = `0.5px solid ${colors.grey[200]}`;
const cellBorderError = `0.5px solid ${colors.error[500]}`;

export const DATE_CELL_BASE: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  height: '100%',
  padding: '0 12px',
  gap: '8px',
  boxSizing: 'border-box',
  transition: 'background-color 0.15s',
};

export const DATE_CELL_HOVER: CSSProperties = {
  backgroundColor: colors.grey[100],
  outline: cellBorderSubtle,
  outlineOffset: '-0.5px',
  cursor: 'pointer',
};

export const DATE_CELL_EDITING: CSSProperties = {
  backgroundColor: colors.white,
  cursor: 'default',
  padding: '0 8px',
};

export const DATE_CELL_ERROR: CSSProperties = {
  borderBottom: cellBorderError,
};

export const DATE_CELL_ERROR_TEXT: CSSProperties = {
  color: colors.error[500],
};

export const DATE_CELL_DISABLED: CSSProperties = {
  backgroundColor: colors.grey[50],
  cursor: 'default',
  pointerEvents: 'none',
};

export const DATE_CELL_DISABLED_TEXT: CSSProperties = {
  color: colors.grey[400],
};

export const DATE_PLACEHOLDER_STYLE: CSSProperties = {
  color: colors.grey[300],
  fontSize: '0.75rem',
  userSelect: 'none',
};
